import * as React from 'react';
import b_ from 'b_';
import { useTranslation } from 'react-i18next';
import RiskInfo from 'components/RiskInfo';
import { IdeaTopCardHeaderFragment } from './__generated__/IdeaTopCardHeaderFragment';

import './index.scss';

interface Props {
  idea: IdeaTopCardHeaderFragment;
}

const b = b_.with('idea-top-card-header');

export const Header: React.FC<Props> = ({ idea }) => {
  const { t } = useTranslation();
  return (
    <div className={b()}>
      <div className={b('wrapper')}>
        <div className={b('logo-wrapper')}>
          <img src={idea.logoUrl} alt="Logo" className={b('logo')} data-testid="logo" />
        </div>
        <div>
          <h2 className={b('name')} data-testid="name">
            {idea.name}
          </h2>
          <div className={b('desc')} data-testid="description">
            {idea.description}
          </div>
        </div>
      </div>
      <div className={b('right-corner')}>
        <div className={b('category')} data-testid="category">
          {t(idea.category)}
        </div>
        <div className={b('risk')}>
          <RiskInfo withIcon withText>
            {idea.riskLevel}
          </RiskInfo>
        </div>
        <p className={b('chart-desc')}>{idea.chartDescription}</p>
      </div>
    </div>
  );
};
